const state = {
  activeTerminal: '',
  terminals: []
}

const mutations = {
  setActiveTerminal(state, terminal) {
    state.activeTerminal = terminal
  },
  setTerminals(state, terminals) {
    state.terminals = terminals
  }
}

const actions = {
  async refetchTerminals({commit}) {
    try {
      const {data: terminals} = await this.$http.get("rest/terminals");

      commit("setTerminals", terminals);
    } catch(err) {
      commit("setTerminals", []);
      return err;
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}